import Vue from "vue";

export default {
  updateAllSaved(state, { key, payload }) {
    Vue.set(state.allSaved, key, payload)
  },
  updateAllChecked(state, { key, payload }) {
    Vue.set(state.allChecked, key, payload)
  },  
  clearSaved(state, payload) {
    payload = {}
    Vue.set(state.allSaved, "naics", payload)
  },
  updateHasResults(state, payload) {
    state.searchHasResults = payload;
  },
  updateExampleByNaics(state, payload) {
    Vue.set(state.hasExamplesByNaics, 0, payload);
  },
  clearExampleByNaics(state, payload) {
    payload = {};
    Vue.set(state.hasExamplesByNaics, 0, payload);
  },
  updateHasNoSelection(state, payload) {
    state.hasNoSelection = payload;
  },
  updateSavedTree(state, payload) {
    state.savedTree = JSON.parse(JSON.stringify(payload));
  },
  updateReducedTree(state, payload) {
    state.reducedTree = JSON.parse(JSON.stringify(payload));
  },
  updateSearchKeyword(state, payload) {
    state.keywordSaved = payload;
  },
  updateInitTree(state, payload) {
    state.initTree= JSON.parse(JSON.stringify(payload));
  }, 
  updateLevelSelectable(state, payload) {
    state.levelSelectable = payload;
  },
  updateMapTopLevelNaics: function(state, payload) {
    return state.mapTopLevelNaics = JSON.parse(JSON.stringify(payload));
  },
  
  updateAlgoliaHitsResult: function(state,payload) {
    return state.algoliaHitsResult = JSON.parse(JSON.stringify(payload));
  },  
  updateAllIndustriesDirecturs:function(state,payload){
    return state.allIndustriesDirecturs = payload;
  },
  updateShowDetail:function(state,payload) {
    return state.showDetail = payload
  },
  updateSelectedNode: function(state, payload) {
    state.nodeInfo = payload;
  }
}
